import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankErrorPage} from 'features/saved-accounts/pages/ConnectBankErrorPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/connect-bank/error',
)({
  component: ConnectBankErrorPage,
});
